import React from "react";

// Recognizable platform brand marks, drawn as inline SVG so no external assets are needed.

export function FacebookLogo({
  className = "h-6 w-6"
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" className={className} aria-hidden="true" data-id="element-567" data-mp="1vw5iduq7un6o">
      <path fill="#1877F2" d="M24 12.07C24 5.4 18.63 0 12 0S0 5.4 0 12.07C0 18.1 4.39 23.1 10.13 24v-8.44H7.08v-3.49h3.05V9.41c0-3.02 1.79-4.69 4.53-4.69 1.31 0 2.68.24 2.68.24v2.97h-1.51c-1.49 0-1.95.93-1.95 1.89v2.25h3.32l-.53 3.49h-2.79V24C19.61 23.1 24 18.1 24 12.07Z" data-id="element-568" data-mp="1vy8ackaxiqe1" />
    </svg>;
}
export function InstagramLogo({
  className = "h-6 w-6"
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" className={className} aria-hidden="true" data-id="element-569" data-mp="1i4hak3n02kvi">
      <defs data-id="element-570" data-mp="1i5sfw7w3g0oq">
        <radialGradient id="ig-grad" cx="30%" cy="107%" r="150%" data-id="element-571" data-mp="1i2ediznfjrha">
          <stop offset="0%" stopColor="#fdf497" data-id="element-572" data-mp="2ojropaqtw5x8" />
          <stop offset="5%" stopColor="#fdf497" data-id="element-573" data-mp="2tjnw7jyqifhj" />
          <stop offset="45%" stopColor="#fd5949" data-id="element-574" data-mp="2tict7md45brh" />
          <stop offset="60%" stopColor="#d6249f" data-id="element-575" data-mp="1064sd2tlo0z3" />
          <stop offset="90%" stopColor="#285AEB" data-id="element-576" data-mp="105v0taswplra" />
        </radialGradient>
      </defs>
      <rect width="24" height="24" rx="6" fill="url(#ig-grad)" data-id="element-577" data-mp="w64ebjaexrsk" />
      <circle cx="12" cy="12" r="4" fill="none" stroke="#fff" strokeWidth="1.8" data-id="element-578" data-mp="r5gec847i0m7" />
      <circle cx="17.4" cy="6.6" r="1.2" fill="#fff" data-id="element-579" data-mp="m6lwp9hz6i3o" />
      <rect x="4.5" y="4.5" width="15" height="15" rx="4.5" fill="none" stroke="#fff" strokeWidth="1.8" data-id="element-580" data-mp="m5u0pxkguicv" />
    </svg>;
}
export function GoogleLogo({
  className = "h-6 w-6"
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" className={className} aria-hidden="true" data-id="element-581" data-mp="cfivm7p1q34e">
      <path fill="#4285F4" d="M23.5 12.27c0-.79-.07-1.54-.2-2.27H12v4.51h6.47a5.53 5.53 0 0 1-2.4 3.63v3h3.87c2.26-2.09 3.56-5.17 3.56-8.87Z" data-id="element-582" data-mp="8ga1h1q3g38b" />
      <path fill="#34A853" d="M12 24c3.24 0 5.96-1.08 7.94-2.91l-3.87-3c-1.08.72-2.45 1.16-4.07 1.16-3.13 0-5.78-2.11-6.73-4.96H1.29v3.09A12 12 0 0 0 12 24Z" data-id="element-583" data-mp="3e1a29svd98b" />
      <path fill="#FBBC05" d="M5.27 14.29a7.2 7.2 0 0 1 0-4.58V6.62H1.29a12 12 0 0 0 0 10.76l3.98-3.09Z" data-id="element-584" data-mp="3ponadza4in1r" />
      <path fill="#EA4335" d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42A11.97 11.97 0 0 0 12 0 12 12 0 0 0 1.29 6.62l3.98 3.09C6.22 6.86 8.87 4.75 12 4.75Z" data-id="element-585" data-mp="3fyyg664wd8lf" />
    </svg>;
}